module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/en-card-drag.6c3a7ca68fa9622801b7.gif";